import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isNil } from 'lodash'
import { WalletOutlined } from '@ant-design/icons'
import { load as loadWallet } from '../../../../modules/finance/redux/wallet/actions'

const Wallet = () => {
  const dispatch = useDispatch()

  const wallet = useSelector(s => s.wallet)

  const companySelect = localStorage.getItem('app.settings.company')

  useEffect(() => {
    if (companySelect && companySelect > 0) {
      dispatch(loadWallet())
    }
  }, [companySelect])

  if (isNil(wallet.data.balance)) {
    return null
  }

  return (
    <>
      <WalletOutlined className="text-muted" style={{ fontSize: 16 }} />
      <span className="ml-2" style={{ marginLeft: '3px' }}>
        {wallet.data.balance} {wallet.data.currency}
      </span>
    </>
  )
}

export default Wallet
